import { Info } from 'lucide-react'
import { clsx } from 'clsx'
import styles from './InfoButton.module.css'

type InfoButtonProps = {
  /** Accessible label, e.g. "Ver regras de escalação". */
  label:      string
  onClick:    () => void
  /** Extra class for positioning by the caller (e.g. absolute on the pitch). */
  className?: string | undefined
  size?:      number | undefined
}

/**
 * Small round "i" button that opens an InfoSheet. Icon-only, so it carries an
 * aria-label and announces that it opens a dialog.
 */
export function InfoButton({ label, onClick, className, size = 15 }: InfoButtonProps) {
  return (
    <button
      type="button"
      className={clsx(styles.button, className)}
      onClick={onClick}
      aria-label={label}
      aria-haspopup="dialog"
      title={label}
    >
      <Info size={size} strokeWidth={2.25} aria-hidden="true" />
    </button>
  )
}
